/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedExternal from '../embed/external.defs.js'

const $nsid = 'app.bsky.actor.status'

export { $nsid }

/** A declaration of a Bluesky account status. */
type Main = {
  $type: 'app.bsky.actor.status'

  /**
   * The status for the account.
   */
  status: 'app.bsky.actor.status#live' | l.UnknownString

  /**
   * An optional embed associated with the status.
   */
  embed?: l.$Typed<EmbedExternal.Main> | l.Unknown$TypedObject

  /**
   * The duration of the status in minutes. Applications can choose to impose minimum and maximum limits.
   */
  durationMinutes?: number
  createdAt: l.DatetimeString
}

export type { Main }

/** A declaration of a Bluesky account status. */
const main = l.record<'literal:self', Main>(
  'literal:self',
  $nsid,
  l.object({
    status: l.string<{ knownValues: ['app.bsky.actor.status#live'] }>(),
    embed: l.optional(
      l.typedUnion(
        [l.typedRef<EmbedExternal.Main>((() => EmbedExternal.main) as any)],
        false,
      ),
    ),
    durationMinutes: l.optional(l.integer({ minimum: 1 })),
    createdAt: l.string({ format: 'datetime' }),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

/** Advertises an account as currently offering live content. */
type Live = 'app.bsky.actor.status#live'

export type { Live }

/** Advertises an account as currently offering live content. */
const live = l.token($nsid, 'live')

export { live }
